export const AUTOMATIC = "A";
export const MANUAL = "M";

export const transmissionsOptions = [AUTOMATIC, MANUAL];
